import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2 {...{
      "id": "span-roleimg-aria-labellove️span"
    }}><span role="img" aria-label="love">{`❤️`}</span></h2>
    <h2 {...{
      "id": "click-below-to-get-your-stuff"
    }}>{`Click below to get your stuff`}</h2>
    <ul>
      <li parentName="ul"><img parentName="li" {...{
          "src": "https://goviral.growthtools.com/images/bullets/1.png",
          "alt": "Why Programmers Work at Night",
          "title": "Why Programmers Work at Night"
        }}></img>{` Free copy of Why Programmers Work at Night `}<span role="img" aria-label="owl">{`🦉`}</span>{` `}<br />{` `}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://leanpub.com/nightowls/c/blog-freebie"
        }}>{`Get the book`}</a></li>
      <li parentName="ul"><img parentName="li" {...{
          "src": "https://goviral.growthtools.com/images/bullets/2.png",
          "alt": "Free React Basics",
          "title": "Free React Basics"
        }}></img>{` 29 videos on React Basics `}<span role="img" aria-label="film">{`🎥`}</span>{`  `}<br />{` `}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.youtube.com/playlist?list=PLF8WgaD4xmjWuh7FTYTealxehOuNor_2S"
        }}>{`Watch now`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      